module.exports = __webpack_public_path__ + "img/allow_use_advertise.ca62004b.svg";